import React from "react";

const CalciumChannelBlockersNote = () => {
  return (
    <div className="bg-white p-2  flex flex-col max-w-[259px] ">
      <p className="text-gray-800 text-sm  font-normal">
        Also used for chest pain and irregular heartbeats.
      </p>
    </div>
  );
};

export default CalciumChannelBlockersNote;
